export default "__VITE_ASSET__CjZh_t5u__"